import { useContext } from "react";

import type { RootStore } from "./root-store";
import { StoreContext } from "./store-context";

export function useStores(): RootStore {
  const rootStore = useContext(StoreContext);

  if (rootStore === null) {
    throw new Error("useStores must be used inside StoreProvider.");
  }

  return rootStore;
}
